import React from 'react'
import { SIM_CARD_STATUS } from '../../root/constants'
import { Typography, makeStyles } from '@material-ui/core'
import { Tooltip } from '../../root/components/common'
import classNames from 'classnames'

export default function SimCardStatus({ status, locale }) {
    const classes = useStyles()

    const config = {
        // ACTIVE
        ACTIVE: { label: SIM_CARD_STATUS.active },
        TEST: {
            label: SIM_CARD_STATUS.active,
            tooltip: true,
            tooltipText: locale.simCards.standByStatusText
        },
        // INACTIVE
        ACTIVE_STANDBY: { label: SIM_CARD_STATUS.active },
        DEACTIVATED: { label: SIM_CARD_STATUS.deactive },
        SUSPENDED: { label: SIM_CARD_STATUS.deactive },
        ACTIVATION_READY: { label: SIM_CARD_STATUS.deactive },
        RETIRED: { label: SIM_CARD_STATUS.deactive },
        // PENDING
        PENDING: {
            label: SIM_CARD_STATUS.pending,
            tooltip: true,
            tooltipText: locale.simCards.pendingStatusText
        }
    }

    if (!status) {
        return null
        // wtf is that logic?
        // return (
        //     <Typography noWrap variant="inherit">
        //         <div
        //             className={classNames(
        //                 classes.labelWrapper,
        //                 classes.statusActive
        //             )}>
        //             <Tooltip
        //                 wrapperClass={classes.tooltipWrapper}
        //                 hover
        //                 text={config['ACTIVE'].tooltipText}>
        //                 <Typography
        //                     className={classNames(
        //                         classes.cellDiv,
        //                         classes.tooltipWrapper
        //                     )}
        //                     variant="inherit"
        //                     noWrap>
        //                     {config['ACTIVE'].label}
        //                 </Typography>
        //             </Tooltip>
        //         </div>
        //     </Typography>
        // )
    }

    return (
        <Typography noWrap variant="inherit">
            <div
                className={`${classes.labelWrapper} ${
                    status === SIM_CARD_STATUS.active
                        ? classes.statusActive
                        : classes.statusDeactive
                }`}>
                {config[status]?.tooltip ? (
                    <Tooltip
                        wrapperClass={classes.tooltipWrapper}
                        hover
                        text={config[status].tooltipText}>
                        <Typography
                            className={classNames(
                                classes.cellDiv,
                                classes.tooltipWrapper
                            )}
                            variant="inherit"
                            noWrap>
                            {config[status].label}
                        </Typography>
                    </Tooltip>
                ) : config[status]?.label ? (
                    <Typography
                        className={classes.cellDiv}
                        variant="inherit"
                        noWrap>
                        {config[status].label}
                    </Typography>
                ) : null}
            </div>
        </Typography>
    )
}

const useStyles = makeStyles(theme => ({
    cellDiv: {
        display: 'flex',
        flexDirection: 'column'
    },
    labelWrapper: {
        borderRadius: theme.borderRadius,
        fontWeight: 500,
        fontSize: '12px',
        padding: '3px 6px',
        backgroundColor: theme.grayLight
    },
    statusDeactive: {
        color: theme.gray,
        backgroundColor: theme.grayLight
    },
    statusActive: {
        color: theme.green,
        backgroundColor: theme.greenLight
    },
    tooltipWrapper: {
        cursor: 'pointer'
    }
}))
